export default theme => ({
  container: {
    padding: 5,
  },
  paper: {
    width: '100%',
    padding: theme.spacing(1)
  }
});
